module.exports = __webpack_public_path__ + "img/bg0601.30a1bcfa.gif";